export default __webpack_public_path__ + "static/media/RTLG3.96913799.webp";